import { DateTime } from 'luxon'

import api from '@functions/api'

import type { CurrentUserPayload } from '@hooks/useCurrentUser'

import { ReportDefaultStateType, ReportKeyType } from '@models/reports'

import type { CampaignModel } from '@models/types'

export const getDateRange = (month: string) => {
  const currentMonthStart = DateTime.local().startOf('month').toISODate()
  const currentMonthEnd = DateTime.local().endOf('month').toISODate()
  const previousMonthStart = DateTime.local().minus({ months: 1 }).startOf('month').toISODate()
  const previousMonthEnd = DateTime.local().minus({ months: 1 }).endOf('month').toISODate()

  if (month === 'current_month'){
    return { startDate: currentMonthStart, endDate: currentMonthEnd }
  }
  return { startDate: previousMonthStart, endDate: previousMonthEnd }
}

export function queueReportExport(url: string, options: object) {
  return api(url, options)
    .then(({ data }: { data: { queued: true }}) => ({
      success: true as const, data,
    }))
    .catch((data: object) => {
      const errors = data?.response?.data?.errors || ['Error creating report']
      return { success: false as const, errors }
    })
}

export type ReportItem = {
  buildReportTitle?: (params: { campaign: CampaignModel }) => string,
  key: ReportKeyType,
  params: ReportDefaultStateType,
  permission: 'advanced' | 'master',
  strings?: object,
  title: string,
  url: string,
}

export const generateReportItems = (state: ReportDefaultStateType): ReportItem[] => {
  const {
    end_date,
    start_date,
  } = state

  return [
    {
      key: 'first_time_right_leaderboard',
      params: { start_date, end_date },
      permission: 'advanced',
      title: 'First Time Right Leaderboard',
      url: '/reports/task_list_items/first_time_right_leaderboard',
    },
    {
      key: 'template_rejections',
      params: { start_date, end_date },
      permission: 'advanced',
      title: 'Template Rejections by Client QC',
      url: '/reports/task_list_items/template_rejections',
    },
  ]
}

export const getReportingPageAllowedReports = (currentUserPayload: CurrentUserPayload): ReportKeyType[] => {
  const {
    isAdmin, isBrandUser,
  } = currentUserPayload

  if (isBrandUser){
    return [
      'first_time_right_leaderboard',
    ]
  }

  if (isAdmin){
    return ['first_time_right_leaderboard', 'template_rejections']
  }

  return []
}

export default queueReportExport
